import { Component, Input, OnInit } from '@angular/core';
import { CustomerwelcomeeditService } from './service/customerwelcomeedit.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Customer } from '../../customers/customer-control/model/customer';
import { Customerwelcome } from './model/customerwelcome';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-customerwelcomeedit',
  templateUrl: './customerwelcomeedit.component.html',
  styleUrls: ['./customerwelcomeedit.component.css']
})
export class CustomerwelcomeeditComponent implements OnInit{
  //define if this component is for the customer welcome or the template welcome
  @Input() isTemplate: boolean;
  @Input() customerId: string;
  welcomeMessage: Customerwelcome;
  showSpinner:boolean = false;
  @Input() customerspec:boolean = false;
  modules = {
    // mention: {
    //   allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
    //   // onSelect: (item, insertItem) => {
    //   //   const editor = this.editor.quillEditor
    //   //   insertItem(item)
    //   //   // necessary because quill-mention triggers changes as 'api' instead of 'user'
    //   //   editor.insertText(editor.getLength() - 1, '', 'user')
    //   // },
    //   source: (searchTerm, renderList) => {
    //     const members = this.projectMembers.concat(this.projectCustomerMembers)
    //     const values = [];
    //     for (let index = 0; index < members.length; index++) {
    //       values.push({id: members[index].personId, value: members[index].fullname});
    //     }

    //     if (searchTerm.length === 0) {
    //       renderList(values, searchTerm)
    //     } else {
    //       const matches = []

    //       values.forEach((entry) => {
    //         if (entry.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1) {
    //           matches.push(entry)
    //         }
    //       })
    //       renderList(matches, searchTerm)
    //     }
    //   }
    // },
    toolbar: [
      [{ 'font': [] }],
      [{ 'size': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      ['link'],          
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['clean']  
    ],
  };

  constructor(private cwesrv: CustomerwelcomeeditService) { }

  ngOnInit() {
    this.welcomeMessage = new Customerwelcome();
    //if template, get the welcome message for the template via orgid
    if(this.isTemplate) {

      this.cwesrv.getWelcomeMessage(SessionHelper.getChoosenOrg()).pipe(untilDestroyed(this)).subscribe((res: any) => {
        if(res == null || res == undefined || res == "no customer welcome found") {
          this.welcomeMessage = new Customerwelcome();
        }else {
          this.welcomeMessage = res;
        }
      });
  }else{
    //if not template, get the welcome message for the customer via customerid
    //console.log(this.customerId);
      this.cwesrv.getWelcomeMessage(this.customerId).pipe(untilDestroyed(this)).subscribe((custwelcom: any) => {
        //if no welcome message for the customer, get the welcome message for the template
        //console.log(custwelcom);
        if(custwelcom == null || custwelcom == undefined || custwelcom == "no customer welcome found") {
          this.cwesrv.getWelcomeMessage(SessionHelper.getChoosenOrg()).pipe(untilDestroyed(this)).subscribe((custwelcometemplate: any) => {
            if(custwelcometemplate == null || custwelcometemplate == undefined || custwelcometemplate == "no customer welcome found") {
              this.welcomeMessage = new Customerwelcome();
            }else {
              this.welcomeMessage = custwelcometemplate;
            }
          });
        }else {
          this.welcomeMessage = custwelcom;
        }
        
    });
    
    
  }
  }

  saveWelcomeMessage() {
    //console.log('old msg',this.welcomeMessage);
    this.showSpinner = true;
    //if no template, create one
    if(this.welcomeMessage.validto == null || this.welcomeMessage.validto == undefined || this.welcomeMessage.validto == "") {
      this.welcomeMessage.validto = new Date("9999-01-01").toISOString();
      this.welcomeMessage.customerId = SessionHelper.getChoosenOrg()+"_0";
    } 
    //If the welcome message came from the template and is being saved for the customer, create a new welcome message
    else if(this.welcomeMessage.customerId.split('_')[0] == SessionHelper.getChoosenOrg() && this.isTemplate == false) {
      this.welcomeMessage.customerId = this.customerId+"_0";
      this.welcomeMessage.validto = new Date("9999-01-01").toISOString();
    }
    //console.log('new msg',this.welcomeMessage);
    //save the welcome message
    this.cwesrv.saveWelcomeMessage(this.welcomeMessage.customerId, JSON.stringify(this.welcomeMessage)).pipe(untilDestroyed(this)).subscribe((res: string) => {
      this.welcomeMessage.customerId = res;
      this.showSpinner = false;
    });
  }

}
